import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const Customers = () => {
  return <TMSIframe path="/customers" />;
};

export default React.memo(Customers);
